<script setup>
import { useRouter } from "vue-router";
import AppDataTable from "@/components/AppDataTable.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { useResourceList } from "@/composables/useResourceList";
import { fetchTasks, deleteTask } from "./api";

const router = useRouter();
const columns = [
  { key: "title",   label: "Title",   sortable: true },
  { key: "actions", label: "Actions", align: "end", width: "150px" },
];
const { rows, loading, error, pendingDelete, deleting, load, askDelete, confirmDelete } =
  useResourceList({
    fetch: fetchTasks,
    remove: deleteTask,
    mapRow: (t) => ({ id: t._id, title: t.title }),
  });
</script>

<template>
  <section>
    <div class="d-flex align-center justify-space-between mb-4 gap-3 flex-wrap">
      <h1 class="text-h5">Manage Tasks</h1>
      <div class="d-flex gap-2">
        <VBtn variant="tonal" @click="load">Refresh</VBtn>
        <VBtn variant="tonal" @click="router.push({ name: 'tasks-batch' })">Batch Add</VBtn>
        <VBtn @click="router.push({ name: 'tasks-new' })">Add Task Group</VBtn>
      </div>
    </div>
    <VAlert v-if="error" type="error" closable class="mb-4" @click:close="error = ''">{{ error }}</VAlert>
    <AppDataTable :columns="columns" :rows="rows" :loading="loading" row-key="id" searchable search-placeholder="Search tasks…" empty-text="No tasks yet.">
      <template #cell-actions="{ row }">
        <VBtn size="small" variant="text" @click.stop="router.push({ name: 'tasks-edit', params: { id: row.id } })">Edit</VBtn>
        <VBtn size="small" color="error" variant="text" @click.stop="askDelete(row)">Delete</VBtn>
      </template>
    </AppDataTable>
    <ConfirmDialog :model-value="pendingDelete !== null" title="Delete task group?" :message="`Delete &quot;${pendingDelete?.title || 'this task'}&quot;?`" :loading="deleting" @update:model-value="pendingDelete = null" @confirm="confirmDelete" />
  </section>
</template>
